import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { Menu, X, Phone } from "lucide-react";
import { NavigationMenu, NavigationMenuItem, NavigationMenuLink, NavigationMenuList } from "@/components/ui/navigation-menu";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
function HeaderMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div className="flex gap-1">
        <div className="h-9 w-16 bg-muted-light animate-pulse rounded-md" />
        <div className="h-9 w-16 bg-muted-light animate-pulse rounded-md" />
        <div className="h-9 w-16 bg-muted-light animate-pulse rounded-md" />
      </div>;
  }
  return <NavigationMenu viewport={false}>
      <NavigationMenuList>
        {menuItems.map((item, i) => <NavigationMenuItem key={item.id} data-index={i}>
            <NavigationMenuLink asChild>
              <Link to={item.href || "#"} className="inline-flex items-center justify-center rounded-md px-4 py-2 text-sm font-medium text-foreground transition-all hover:bg-primary/10 hover:text-primary focus:bg-primary/10 focus:text-primary focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2">
                {item.label}
              </Link>
            </NavigationMenuLink>
          </NavigationMenuItem>)}
      </NavigationMenuList>
    </NavigationMenu>;
}
function MobileMenuConsumer({
  onClose
}: {
  onClose: () => void;
}) {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div className="flex flex-col gap-2 p-4">
        <div className="h-12 w-full bg-muted-light animate-pulse rounded-md" />
        <div className="h-12 w-full bg-muted-light animate-pulse rounded-md" />
        <div className="h-12 w-full bg-muted-light animate-pulse rounded-md" />
      </div>;
  }
  return <nav className="flex flex-col gap-1 p-4">
      {menuItems.map((item, i) => <Link key={item.id} data-index={i} to={item.href || "#"} onClick={onClose} className="inline-flex items-center justify-start rounded-md px-4 py-3 text-base font-medium text-foreground transition-all hover:bg-primary/10 hover:text-primary focus:bg-primary/10 focus:text-primary focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2">
          {item.label}
        </Link>)}
    </nav>;
}
export default function Header() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };
  const closeMobileMenu = () => {
    setMobileMenuOpen(false);
  };
  return <header className="bg-background border-b border-border sticky top-0 z-50 shadow-soft">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          {}
          <div className="flex items-center gap-4">
            <div className="flex-shrink-0">
              <Link to="/columbia-valley" className="focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2 rounded-md">
                <img src="https://columbiavalleywaste.com/wp-content/uploads/2025/10/cropped-cropped-website_logo_main-1.png" alt="Columbia Valley Waste & Recycling" className="!w-[90px] !h-[26px]" />
              </Link>
            </div>
            <div className="flex items-center gap-2 text-sm font-medium text-muted-foreground border-l border-border pl-4">
              <Phone className="size-4" />
              236-302-4912
            </div>
          </div>

          {}
          <nav className="hidden md:flex items-center space-x-1">
            <MenuProvider menu_id="17">
              <HeaderMenuConsumer />
            </MenuProvider>
          </nav>

          {}
          <div className="hidden md:flex items-center">
            <Button asChild variant="default" size="default" className="shadow-sm hover:shadow-medium hover:-translate-y-0.5 transition-all duration-[var(--duration-medium)] ease-[var(--ease-spring)]">
              
            </Button>
          </div>

          {}
          <div className="flex md:hidden items-center">
            <Button variant="ghost" size="icon" onClick={toggleMobileMenu} aria-label={mobileMenuOpen ? "Close menu" : "Open menu"} aria-expanded={mobileMenuOpen} className="hover:bg-primary/10 focus-visible:ring-2 focus-visible:ring-primary">
              {mobileMenuOpen ? <X className="size-6" /> : <Menu className="size-6" />}
            </Button>
          </div>
        </div>
      </div>

      {}
      {mobileMenuOpen && <>
          {}
          <div className="fixed inset-0 bg-black/20 backdrop-blur-sm z-40 md:hidden animate-fade-up" onClick={closeMobileMenu} aria-hidden="true" />

          {}
          <div className="fixed top-16 left-0 right-0 bg-background border-b border-border shadow-medium z-50 md:hidden animate-fade-up">
            <MenuProvider menu_id="17">
              <MobileMenuConsumer onClose={closeMobileMenu} />
            </MenuProvider>
            
            {}
            
          </div>
        </>}
    </header>;
}